//
// School store
//
// Contains all schools accessible to the currently
// authenticated user.
//

import { LOGOUT } from './auth';
import { RECEIVE_ENTITIES } from './user';
import { CLASS_CREATED, CLASS_DELETED } from './classes';

// ------------------------------------
// Initial state
// ------------------------------------

const initialState = {
  items: {}
};

// ------------------------------------
// Reducer
// ------------------------------------

export default (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_ENTITIES:
      return {
        items: action.entities.schools || {}
      };

    case CLASS_CREATED:
      const { id, school_id } = action.cls;
      const items = Object.assign({}, state.items);
      const item = items[school_id];

      items[item.id] = Object.assign({}, item, {
        classes: [ ...item.classes, id ]
      });

      return { items };

    case CLASS_DELETED: {
      const items = Object.assign({}, state.items);
      const item = Object.values(items).find(item =>
        item.classes.includes(action.id)
      );

      items[item.id] = Object.assign({}, item, {
        classes: item.classes.filter(id => id !== action.id)
      });

      return { items };
    }

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

// ------------------------------------
// Utils
// ------------------------------------

export const getAllSchools = state => {
  return Object.values(state.schools.items);
};

export const getSchools = (state, ids) => {
  const { items } = state.schools;
  return ids.map(id => ({ ...items[id] }));
};

export const getSchool = (state, id) => {
  const { items } = state.schools;
  return { ...items[id] };
};



// WEBPACK FOOTER //
// ./src/store/modules/schools.js